import React from 'react';
import ImgSlider from './ImgSlider';
// import ImageSlider from './ImageSlider';
import styles from './knowus.module.css';
import CountUp from 'react-countup'
// import Image from '../../assets/keno.png';

const KnowUs = () => {

   
    return (
        <div className={styles["know-us-container"]} id='about' >
            <section className={styles["section-knowus"]}>
                <div className={styles["text"]}>
            
                    <h2 
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="300"
                    > We are innovating in oil and gas energy </h2>

                    <div 
                    data-aos="fade-up"
                    data-aos-easing="linear"
                    data-aos-duration="400"
                    className={styles["block"]}></div>
                
                    
                </div>


                <div className={styles["content"]}> 
                        <div>
                            <p
                                data-aos="fade-up"
                                data-aos-easing="linear"
                                data-aos-duration="400"
                                > Helix Energy Solutions excels in high-volume oil refining, focusing on meeting market demand for quality petroleum products. Over the years, the company has consistently modernized its refineries, enhancing product quality and competitiveness. This modernization program, the most ambitious in the oil industry, fulfills the company's obligations under a quadripartite agreement.
                                Traditionally, most of  Helix Energy Solutions's gas has been sold through long-term contracts to large European gas companies and suppliers. In the absence of a separate market price for gas, the sale price has often been indexed to the price of oil.
                                At  Helix Energy Solutions, we believe in transforming challenges into opportunities. We continuously seek new ways to leverage our expertise in the energy industry, exploring advancements in new energy sources while driving innovation in oil and gas globally.
                            </p>
                        </div>

                        <div 
                              data-aos="fade-up"
                              data-aos-easing="linear"
                              data-aos-duration="400"
                            className={styles["stats"]}>

                                <div className={styles["stats-data"]} >
                                    <CountUp start={0} end={30} duration={10} className={styles["count"]}/> 
                                    <p>years experience</p>
                                </div>
                                <div className={styles["stats-data"]}>
                                    <CountUp start={9000} end={10000} duration={10} className={styles["count"]}/> 
                                    <p>petroleum engineers</p>
                                </div>
                                <div className={styles["stats-data"]}>
                                    <CountUp start={0} end={14000} duration={10} className={styles["count"]}/> 
                                    <p>project completed</p>
                                </div>
                            
                        </div>

                </div>
            </section>

           <ImgSlider />

            {/* <ImageSlider /> */}

        </div>
    )
}

export default KnowUs
